/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AttachmentsListDisplayErrorComponent} from './attachments-list-display-error.component';
import {FilePreviewModule} from '../../../shared/file-preview/file-preview.module';

@NgModule({
    declarations: [AttachmentsListDisplayErrorComponent],
    imports: [
        CommonModule,
        FilePreviewModule
    ],
    exports: [AttachmentsListDisplayErrorComponent]
})
export class AttachmentsListDisplayErrorModule {
}
